module.exports = __webpack_public_path__ + "img/manual.77574b34.jpg";